import { createSlice } from "@reduxjs/toolkit";

const sortByDateFn = (a, b) => (new Date(b.expire_date) - new Date(a.expire_date))

export const operationsSlice = createSlice({
    name: 'operations',
    initialState: [],
    reducers: {
        empty: state => {
            return []
        },
        setOperations: (state, action) => {
            if (Array.isArray(action?.payload)) {
                const sorted = action?.payload?.sort(sortByDateFn);
                return sorted
            }
        },
        add: (state, action) => {
            const existingIndex = state.findIndex((op) => op.id === Number(action.payload?.id));

            let updatedState;

            if (existingIndex !== -1) {
              // Replace the existing item with the updated one
              updatedState = [...state];
              updatedState[existingIndex] = {
                ...updatedState[existingIndex],
                ...action.payload,
              };
            } else {
              // Add the new item
              updatedState = [...state, action.payload];
            }

            // Sort and return
            return updatedState.sort(sortByDateFn);
        },
        updateOp: (state, action) => {
            const foundedIndex = state.findIndex((op) => Number(op.id) === Number(action.payload?.id));
            console.log('DEBUG updateOp: foundedIndex=', foundedIndex, 'op.id=', action.payload?.id, 'state.length=', state.length);
            if (foundedIndex !== -1) {
                // Directly mutate the state at the found index
                state[foundedIndex] = { ...state[foundedIndex], ...action.payload };
                console.log('DEBUG updateOp: Updated operation at index', foundedIndex, 'new start_date=', state[foundedIndex]?.start_date);
                return state; // This ensures the updated state is returned
            } else {
                console.error('DEBUG updateOp: Operation not found. Looking for id:', action.payload?.id, 'Available ids:', state.map(op => op.id));
                throw new Error('Operation not found');
            }
        },
        updateNote: (state, action) => {
            const foundedIndex = state.findIndex((operation) => operation.id === Number(action.payload?.id));
            if (foundedIndex !== -1) {
                state[foundedIndex] = {
                    ...state[foundedIndex],
                    chat_notes: action.payload.chat_notes,
                };
            }
            return state;
        },
        removeOp: (state, action) => {
            return state.filter(operation => Number(operation.id) !== Number(action.payload?.id));
        }
    }
});

export const {
    empty, 
    setOperations,
    updateOp,
    updateNote,
    add, 
    removeOp
} = operationsSlice.actions;

export default operationsSlice.reducer;